import React from 'react';
import PropTypes from 'prop-types';

const Legend = ({items, colors, selectedCategory}) => {
  return (
    <>
      <h5 className="mt-2">Legend : {`${selectedCategory ? selectedCategory.label : 'None'}`}</h5>
      <ul style={{listStyleType: 'none', paddingLeft: 0}}>
        {items.map((item, index) => (
          <li key={index} style={{display: 'flex', alignItems: 'center', marginBottom: '8px'}}>
            <div
              style={{
                width: '20px',
                height: '20px',
                backgroundColor: Object.values(colors)[index],
                marginRight: '10px',
              }}
            />
            {item.text}
          </li>
        ))}
      </ul>
    </>
  );
};

Legend.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
    })
  ).isRequired,
  colors: PropTypes.object.isRequired,
  selectedCategory: PropTypes.shape({
    label: PropTypes.string,
  }),
};

Legend.defaultProps = {
  selectedCategory: null,
};

export default Legend;
